import React from 'react';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/Toast';

import { useAuth } from '../../../../../../hooks/Auth';
import { FiMail, FiSend } from 'react-icons/fi';
import Whatsapp from '../../../../../../components/Whatsapp';
import { authTitle } from '../../../../../../config';
import { FaMailBulk } from 'react-icons/fa';
import { useLoading } from 'src/hooks/LoadingHook';
import { useModal } from 'src/hooks/Modal';
import sleep from 'src/utils/sleep';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function ContactModule({

  lineData,

}: ICreateModule): JSX.Element {

  const { addLoading, removeLoading } = useLoading();
  const { addModal } = useModal();
  const { addToast } = useToast();




  const sendSingleEmailAgain = async (user_hash, index, length) => {


    try {
      await api.post(`/send-invitation-to-user/${lineData?.hash}/${user_hash}/yes`);

      addToast({ title: `${index + 1} / ${length} - Enviado com sucesso`, type: 'success' });

    }
    catch (err) {

      addToast({ title: `${index + 1} / ${length} - ${err?.response?.data?.message || 'Erro ao enviar'} `, type: 'error' })
    }

    return;

  }


  const sendSingleEmail = async (user_hash, index, length) => {


    try {
      await api.post(`/send-invitation-to-user/${lineData?.hash}/${user_hash}`);

      addToast({ title: `${index + 1} / ${length} - Enviado com sucesso`, type: 'success' });

    }
    catch (err) {

      addToast({ title: `${index + 1} / ${length} - ${err?.response?.data?.message || 'Erro ao enviar'} `, type: 'error' })
    }

    return;

  }

  const sendMail = async () => {


    const students = await api.get('/students', { params: { limitItems: 100000, where: { project_id: lineData?.project_id } } })

    let x = 0;

    while (x < students?.data?.rows?.length) {

      const student = students?.data?.rows?.[x];

      await sendSingleEmail(student?.user_hash, x, students?.data?.rows?.length);
      await sleep(200);


      x += 1;
    }


  }


  const sendMailAgainList = async () => {


    const invitations = await api.get('/invitation-confirmation', { params: { limitItems: 100000, where: { project_id: lineData?.project_id, confirmated: 'Aguardando' } } })

    let x = 0;

    while (x < invitations?.data?.rows?.length) {

      const invitation = invitations?.data?.rows?.[x];

      await sendSingleEmailAgain(invitation?.user_hash, x, invitations?.data?.rows?.length);
      await sleep(200);


      x += 1;
    }


  }

  const sendMailCheck = () => {

    addModal({
      title: '', theme: 'whiteModalMedium', content: <>
        <h2 style={{ color: '#333', fontSize: '#333', width: '100%', textAlign: 'center' }}>Confirmar envio?</h2>
        <button className='greenButton2' style={{ margin: '10px auto' }} type='button' onClick={() => { sendMail() }}>Enviar</button>

      </>
    })

  }

  const resendMail = async () => {


    const students = await api.get('/invitation-confirmation', { params: { limitItems: 100000, where: { project_id: lineData?.project_id, confirmated: 'Aguardando', category_id: { "$ne": 'Patrocinador' } } } })

    let x = 0;

    while (x < students?.data?.rows?.length) {

      const student = students?.data?.rows?.[x];

      await sendSingleEmailAgain(student?.user_hash, x, students?.data?.rows?.length);
      await sleep(200);


      x += 1;
    }


  }

  const sendMailAgain = () => {

    addModal({
      title: '', theme: 'whiteModalMedium', content: <>
        <h2 style={{ color: '#333', fontSize: '14px' }}>Você deseja reenviar para todos os participantes que não confirmaram?</h2>

        <button className='greenButton2' style={{ margin: '10px auto' }} type='button' onClick={() => { sendMailAgainList() }}>Enviar</button>

      </>
    })

  }


  const resendMailAgain = () => {

    addModal({
      title: '', theme: 'whiteModalMedium', content: <>
        <h2 style={{ color: '#333', fontSize: '14px' }}>Você deseja reenviar para todos os participantes que não confirmaram?</h2>

        <button className='greenButton2' style={{ margin: '10px auto' }} type='button' onClick={() => { resendMail() }}>Enviar</button>

      </>
    })

  }



  const moduleUpdate = (data: Record<string, any>): JSX.Element => (
    <>
      <button className='lineIcon' title='Enviar para não enviados' onClick={() => { sendMailCheck() }}><FaMailBulk /></button>
      <button className='lineIcon' title='Reenviar para todos os não confirmados' onClick={() => { resendMailAgain() }}><FiMail /></button>
    </>
  );

  return moduleUpdate(lineData);
}
